import OtherCategorizedHoldingDocuments from "./other-categorized-holding-documents";

export default OtherCategorizedHoldingDocuments;
